import { SVGInterface } from "../../interface";

const Download = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6 10.5L12 16.5L18 10.5L16.59 9.09L13 12.67V3H11V12.67L7.41 9.09L6 10.5Z"
      fill={color || "#0E171F"}
    />
    <path d="M19 21H5V19H19V21Z" fill={color || "#0E171F"} />
  </svg>
);

export default Download;
